/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import './Reports.css';
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import { useNavigate } from 'react-router-dom';

const ReportsLinkCard = ({ title, subtitle, onClick }) => {
	return (
		<div className="bg-white rounded-[10px] w-full p-[30px] cursor-pointer" onClick={onClick}>
			<h3 className="text-[1.6rem] text-pd-blue font-bold pb-[10px]">{title}</h3>
			<p>{subtitle}</p>
		</div>
	);
};

const Reports = () => {
	const navigate = useNavigate();
	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="reports-main-div px-60 pt-60">
				<div className="mb-48">
					<h3 className="mb-28" style={{ fontSize: '20px', fontWeight: '700' }}>
						Room Reports
					</h3>
					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/reports-checkin')}
							subtitle="Review student check-in information"
							title="Attendance Report"
						/>
						<ReportsLinkCard
							onClick={() => navigate('/reports-roomRatio')}
							subtitle="Review detailed ratio of each room"
							title="Ratio"
						/>
					</div>
					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/RoomCheck')}
							subtitle="Review real time class ratio for staff in classroom"
							title="Room Check"
						/>
						<div className="p-[30px] rounded-[10px] w-full hidden md:block" />
					</div>
				</div>
				<div className="mb-48">
					<h3 className="mb-28" style={{ fontSize: '18px', fontWeight: '700' }}>
						Student Reports
					</h3>
					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/reports-staff')}
							subtitle="Review staff information"
							title="Staff"
						/>
						<ReportsLinkCard
							onClick={() => navigate('/reports-enrolledStudent')}
							subtitle="Review enrolled student information"
							title="Enrolled Student Info"
						/>
					</div>

					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/reports-activity')}
							subtitle="Review activities logged by teacher in your classroom"
							title="Activities"
						/>
						<ReportsLinkCard
							onClick={() => navigate('/reports-age')}
							subtitle="Review age and birthday of students"
							title="Age"
						/>
					</div>
					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/reports-allergy')}
							subtitle="Review student allergies by classroom or school"
							title="Allergies"
						/>
						<ReportsLinkCard
							onClick={() => navigate('/reports-contact')}
							subtitle="Review contacts information for parents and approved pickups"
							title="Contacts"
						/>
					</div>
					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/reports-immunization')}
							subtitle="Review immunization records of your students"
							title="Immunization Records"
						/>
						<ReportsLinkCard
							onClick={() => navigate('/reports-due-overdue')}
							subtitle="Review upcoming and overdue immunizations"
							title="Immunizations due/overdue"
						/>
					</div>
					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/reports-medication')}
							subtitle="Review student medical"
							title="Medical"
						/>
						<ReportsLinkCard
							onClick={() => navigate('/reports-meal')}
							subtitle="Review summary of meals served at your school"
							title="Meals"
						/>
					</div>
				</div>
				<div>
					<h3 className="mb-28" style={{ fontSize: '18px', fontWeight: '700' }}>
						Financial Reports
					</h3>
					<div className="flex flex-col md:flex-row mb-28 gap-28 md:gap-48">
						<ReportsLinkCard
							onClick={() => navigate('/reports-subscription')}
							subtitle="Review parent subscription information"
							title="Parent Subscription Reports"
						/>
						<ReportsLinkCard
							onClick={() => navigate('/reports-royalties')}
							subtitle="Review royalty related information"
							title="Royalty Reports"
						/>
					</div>
				</div>
				{/* <div>
						<h3 className="mb-28" style={{ fontSize: '18px', fontWeight: '700' }}>
							Other Reports
						</h3>
						<div className="flex flex-nowrap mb-28 gap-28 md:gap-48">
							<ReportsLinkCard
								title="Quick Reports"
								subtitle="Export report of variety of activites"
								onClick={() => navigate('/reports-download')}
							/>
						</div>
					</div> */}
			</div>
		</FuseAnimate>
	);
};
export default Reports;
